import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './NavigationTabs.scss';

interface NavigationTabsProps<T extends string> {
  selectedTab: T;
  onSelect: (tab: T) => void;
  tabTranslations: Record<string, TranslationTag>;
}
const NavigationTabs = <T extends string>({
  selectedTab,
  onSelect,
  tabTranslations
}: NavigationTabsProps<T>) => (
  <nav className={styles.nav} data-testid="nav-tabs">
    {Object.keys(tabTranslations).map((key) => (
      <button
        key={key}
        className={classNames(styles.button, {
          [styles.active]: selectedTab === key
        })}
        onClick={() => onSelect(key as T)}
        data-tab={key}
      >
        <Translation {...tabTranslations[key]} />
      </button>
    ))}
  </nav>
);

export default NavigationTabs;
